import { motion } from "framer-motion";
import { Truck, Boxes, Package, Briefcase, Building2, Handshake, ArrowUpRight } from "lucide-react";

const services = [
  { Icon: Boxes, title: "Trading & Importation", body: "Continuously expanding importation of high-quality, diverse products from trusted manufacturers worldwide." },
  { Icon: Briefcase, title: "Management Solutions", body: "Top-of-the-line management infrastructure refined since 2013 — optimized at every level of the supply chain." },
  { Icon: Truck, title: "Modern Logistics", body: "Modernized logistics and routing that adapt quickly to consumer trends and seasonal demand cycles." },
  { Icon: Package, title: "High-Volume Distribution", body: "Reliable, large-scale distribution to supermarkets, convenience stores, sub-distributors, and wholesale partners." },
  { Icon: Building2, title: "Retail Partnerships", body: "Tailored programs for grocery chains, mini-marts, and convenience-store networks — pricing, packaging, and replenishment cycles to match." },
  { Icon: Handshake, title: "Supplier Representation", body: "We act as the most reliable regional partner for suppliers, expanding their reach into Philippine retail channels." },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mb-14"
        >
          <p className="text-sm uppercase tracking-widest font-semibold text-blue-600 mb-3">What We Do</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold text-slate-900">
            Strategic management meets dynamic trade.
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            From meticulous vendor selection to high-volume distribution, our services cover the full arc of moving consumer goods — efficiently, reliably, and at scale.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map(({ Icon, title, body }, i) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              data-testid={`service-card-${title.toLowerCase().replace(/\s+/g, "-").replace(/&/g, "and")}`}
              className="group relative bg-white rounded-2xl border border-slate-200 hover:border-blue-200 p-8 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-default"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-50 to-emerald-50 text-blue-600 mb-5 group-hover:scale-110 transition-transform">
                <Icon size={22} />
              </span>
              <h3 className="font-heading text-xl font-semibold text-slate-900 mb-2.5">{title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{body}</p>
              <ArrowUpRight size={18} className="absolute top-7 right-7 text-slate-300 group-hover:text-blue-600 group-hover:rotate-12 transition-all" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
